import { Injectable } from '@angular/core';
import { StoreConfig, Store } from '@datorama/akita';
import { Barcode } from './barcode.model';

function createInitialState() {
  return {} as Barcode;
}


@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'barcode' })
export class BarcodeStore extends Store<Barcode> {
  constructor() {
    super(createInitialState());
  }
}

